module.exports = __webpack_public_path__ + "media/penguin.ff5cb500.mp3";